export const links = {
    terms: 'https://www.guidde.com/eula',
    privacyPolicy: 'https://www.guidde.com/privacy-policy',
    guiddeWebsite: 'https://www.guidde.com',
}
